module.exports = __webpack_public_path__ + "assets/img/a173-kh.svg";